import { render, staticRenderFns } from "./SynergridNewRequestForm.vue?vue&type=template&id=3447cae1"
import script from "./SynergridNewRequestForm.vue?vue&type=script&lang=ts"
export * from "./SynergridNewRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports